import authComponent from './auth.component';
import signinComponent from './signin/signin.component';
import passwordComponent from './password/password.component';

import passwordModule from './password/password';

const AuthModule = angular
    .module('auth', [
      passwordModule.name
    ])
    .component('auth', authComponent)
    .component('signin', signinComponent);

export default AuthModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/auth.js
 **/